import React from 'react';
import AppBar from '../../components/AppBar';
import Footer from '../../components/Footer';
import Purchase from '../Sections/PurchaseSection';

const PurchasePage = () => {
  return (
    <>
      <AppBar />
      <Purchase />
      <Footer />
    </>
  );
};

export default PurchasePage;
